// 国家数据多语言配置
export const countriesData = {
  "zh-CN": [
    {
      "code": "+86",
      "name": "中国大陆",
      "pattern": "^1[3-9]\\d{9}$",
      "placeholder": "请输入11位手机号",
      "maxLength": 11
    },
    {
      "code": "+852",
      "name": "香港",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+853",
      "name": "澳门",
      "pattern": "^6\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+886",
      "name": "台湾",
      "pattern": "^9\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+81",
      "name": "日本",
      "pattern": "^[789]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+82",
      "name": "韩国",
      "pattern": "^1[0-9]\\d{7,8}$",
      "placeholder": "请输入9-10位手机号",
      "maxLength": 10
    },
    {
      "code": "+65",
      "name": "新加坡",
      "pattern": "^[89]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+60",
      "name": "马来西亚",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+66",
      "name": "泰国",
      "pattern": "^[689]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+84",
      "name": "越南",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+62",
      "name": "印度尼西亚",
      "pattern": "^8[1-9]\\d{6,8}$",
      "placeholder": "请输入8-10位手机号",
      "maxLength": 10
    },
    {
      "code": "+63",
      "name": "菲律宾",
      "pattern": "^9\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+91",
      "name": "印度",
      "pattern": "^[6-9]\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+971",
      "name": "阿联酋",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+966",
      "name": "沙特阿拉伯",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+90",
      "name": "土耳其",
      "pattern": "^5[0-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+7",
      "name": "俄罗斯",
      "pattern": "^9\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+49",
      "name": "德国",
      "pattern": "^1[5-7]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+33",
      "name": "法国",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+39",
      "name": "意大利",
      "pattern": "^3\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+34",
      "name": "西班牙",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+31",
      "name": "荷兰",
      "pattern": "^6\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+44",
      "name": "英国",
      "pattern": "^7\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+1",
      "name": "美国/加拿大",
      "pattern": "^[2-9]\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+52",
      "name": "墨西哥",
      "pattern": "^[1-9]\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+55",
      "name": "巴西",
      "pattern": "^[1-9]\\d{10}$",
      "placeholder": "请输入11位手机号",
      "maxLength": 11
    },
    {
      "code": "+61",
      "name": "澳大利亚",
      "pattern": "^4\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+64",
      "name": "新西兰",
      "pattern": "^2\\d{7,8}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+27",
      "name": "南非",
      "pattern": "^[6-8]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+93",
      "name": "阿富汗",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+355",
      "name": "阿尔巴尼亚",
      "pattern": "^6[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+213",
      "name": "阿尔及利亚",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+376",
      "name": "安道尔",
      "pattern": "^[3-6]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+244",
      "name": "安哥拉",
      "pattern": "^9[1-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+374",
      "name": "亚美尼亚",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+297",
      "name": "阿鲁巴",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+43",
      "name": "奥地利",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "请输入9-10位手机号",
      "maxLength": 10
    },
    {
      "code": "+994",
      "name": "阿塞拜疆",
      "pattern": "^[4-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+973",
      "name": "巴林",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+880",
      "name": "孟加拉国",
      "pattern": "^1[3-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+375",
      "name": "白俄罗斯",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+32",
      "name": "比利时",
      "pattern": "^4[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+501",
      "name": "伯利兹",
      "pattern": "^6[0-9]\\d{5}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+229",
      "name": "贝宁",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+975",
      "name": "不丹",
      "pattern": "^[1-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+591",
      "name": "玻利维亚",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+387",
      "name": "波黑",
      "pattern": "^6[0-9]\\d{6,7}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+267",
      "name": "博茨瓦纳",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+673",
      "name": "文莱",
      "pattern": "^[78]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+359",
      "name": "保加利亚",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+226",
      "name": "布基纳法索",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+257",
      "name": "布隆迪",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+855",
      "name": "柬埔寨",
      "pattern": "^[1-9]\\d{7,8}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+237",
      "name": "喀麦隆",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+238",
      "name": "佛得角",
      "pattern": "^[59]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+236",
      "name": "中非",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+235",
      "name": "乍得",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+56",
      "name": "智利",
      "pattern": "^9\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+57",
      "name": "哥伦比亚",
      "pattern": "^3\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+269",
      "name": "科摩罗",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+243",
      "name": "刚果(金)",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+506",
      "name": "哥斯达黎加",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+385",
      "name": "克罗地亚",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+53",
      "name": "古巴",
      "pattern": "^5\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+357",
      "name": "塞浦路斯",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+420",
      "name": "捷克",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+45",
      "name": "丹麦",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+253",
      "name": "吉布提",
      "pattern": "^7[0-9]\\d{5}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+593",
      "name": "厄瓜多尔",
      "pattern": "^9\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+20",
      "name": "埃及",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+503",
      "name": "萨尔瓦多",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+240",
      "name": "赤道几内亚",
      "pattern": "^[2-3]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+372",
      "name": "爱沙尼亚",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+251",
      "name": "埃塞俄比亚",
      "pattern": "^9\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+679",
      "name": "斐济",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+358",
      "name": "芬兰",
      "pattern": "^[4-5]\\d{7,8}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+241",
      "name": "加蓬",
      "pattern": "^[0-1]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+220",
      "name": "冈比亚",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+995",
      "name": "格鲁吉亚",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+233",
      "name": "加纳",
      "pattern": "^[2-5]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+30",
      "name": "希腊",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "请输入9-10位手机号",
      "maxLength": 10
    },
    {
      "code": "+502",
      "name": "危地马拉",
      "pattern": "^[4-5]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+224",
      "name": "几内亚",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+592",
      "name": "圭亚那",
      "pattern": "^[6-7]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+509",
      "name": "海地",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+504",
      "name": "洪都拉斯",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+36",
      "name": "匈牙利",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+354",
      "name": "冰岛",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+98",
      "name": "伊朗",
      "pattern": "^9[0-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+964",
      "name": "伊拉克",
      "pattern": "^7[0-9]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+353",
      "name": "爱尔兰",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+972",
      "name": "以色列",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+962",
      "name": "约旦",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+254",
      "name": "肯尼亚",
      "pattern": "^[7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+965",
      "name": "科威特",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+996",
      "name": "吉尔吉斯斯坦",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+856",
      "name": "老挝",
      "pattern": "^[2-9]\\d{7,8}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+371",
      "name": "拉脱维亚",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+961",
      "name": "黎巴嫩",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+266",
      "name": "莱索托",
      "pattern": "^[5-6]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+231",
      "name": "利比里亚",
      "pattern": "^[4-7]\\d{6,7}$",
      "placeholder": "请输入7-8位手机号",
      "maxLength": 8
    },
    {
      "code": "+218",
      "name": "利比亚",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+423",
      "name": "列支敦士登",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+370",
      "name": "立陶宛",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+352",
      "name": "卢森堡",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+261",
      "name": "马达加斯加",
      "pattern": "^[3-4]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+265",
      "name": "马拉维",
      "pattern": "^[1-9]\\d{6,8}$",
      "placeholder": "请输入7-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+960",
      "name": "马尔代夫",
      "pattern": "^[7-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+223",
      "name": "马里",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+356",
      "name": "马耳他",
      "pattern": "^[79]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+222",
      "name": "毛里塔尼亚",
      "pattern": "^[2-4]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+230",
      "name": "毛里求斯",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+373",
      "name": "摩尔多瓦",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+377",
      "name": "摩纳哥",
      "pattern": "^[4-6]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+976",
      "name": "蒙古",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+382",
      "name": "黑山",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+212",
      "name": "摩洛哥",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+258",
      "name": "莫桑比克",
      "pattern": "^8[2-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+95",
      "name": "缅甸",
      "pattern": "^9\\d{7,9}$",
      "placeholder": "请输入8-10位手机号",
      "maxLength": 10
    },
    {
      "code": "+264",
      "name": "纳米比亚",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+977",
      "name": "尼泊尔",
      "pattern": "^9[6-8]\\d{8}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+505",
      "name": "尼加拉瓜",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+227",
      "name": "尼日尔",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+234",
      "name": "尼日利亚",
      "pattern": "^[7-9]\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+47",
      "name": "挪威",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+968",
      "name": "阿曼",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+92",
      "name": "巴基斯坦",
      "pattern": "^3\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+507",
      "name": "巴拿马",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+675",
      "name": "巴布亚新几内亚",
      "pattern": "^[7-9]\\d{6,7}$",
      "placeholder": "请输入7-8位手机号",
      "maxLength": 8
    },
    {
      "code": "+595",
      "name": "巴拉圭",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+51",
      "name": "秘鲁",
      "pattern": "^9\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+48",
      "name": "波兰",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+351",
      "name": "葡萄牙",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+974",
      "name": "卡塔尔",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+40",
      "name": "罗马尼亚",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+250",
      "name": "卢旺达",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+685",
      "name": "萨摩亚",
      "pattern": "^[5-9]\\d{4,6}$",
      "placeholder": "请输入5-7位手机号",
      "maxLength": 7
    },
    {
      "code": "+378",
      "name": "圣马力诺",
      "pattern": "^[3-6]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+221",
      "name": "塞内加尔",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+381",
      "name": "塞尔维亚",
      "pattern": "^[6-7]\\d{7,8}$",
      "placeholder": "请输入8-9位手机号",
      "maxLength": 9
    },
    {
      "code": "+248",
      "name": "塞舌尔",
      "pattern": "^[2-4]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+232",
      "name": "塞拉利昂",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+421",
      "name": "斯洛伐克",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+386",
      "name": "斯洛文尼亚",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+677",
      "name": "所罗门群岛",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+252",
      "name": "索马里",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+249",
      "name": "苏丹",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+597",
      "name": "苏里南",
      "pattern": "^[6-8]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+268",
      "name": "斯威士兰",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+46",
      "name": "瑞典",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+41",
      "name": "瑞士",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+963",
      "name": "叙利亚",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+992",
      "name": "塔吉克斯坦",
      "pattern": "^[4-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+255",
      "name": "坦桑尼亚",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+228",
      "name": "多哥",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+676",
      "name": "汤加",
      "pattern": "^[5-9]\\d{5}$",
      "placeholder": "请输入6位手机号",
      "maxLength": 6
    },
    {
      "code": "+216",
      "name": "突尼斯",
      "pattern": "^[2-5]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+993",
      "name": "土库曼斯坦",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+256",
      "name": "乌干达",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+380",
      "name": "乌克兰",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+598",
      "name": "乌拉圭",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "请输入8位手机号",
      "maxLength": 8
    },
    {
      "code": "+998",
      "name": "乌兹别克斯坦",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+678",
      "name": "瓦努阿图",
      "pattern": "^[5-7]\\d{6}$",
      "placeholder": "请输入7位手机号",
      "maxLength": 7
    },
    {
      "code": "+58",
      "name": "委内瑞拉",
      "pattern": "^4\\d{9}$",
      "placeholder": "请输入10位手机号",
      "maxLength": 10
    },
    {
      "code": "+967",
      "name": "也门",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+260",
      "name": "赞比亚",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    },
    {
      "code": "+263",
      "name": "津巴布韦",
      "pattern": "^[7-8]\\d{8}$",
      "placeholder": "请输入9位手机号",
      "maxLength": 9
    }
  ],
  "zh-TW": [
    {
      "code": "+86",
      "name": "中國大陸",
      "pattern": "^1[3-9]\\d{9}$",
      "placeholder": "請輸入11位手機號",
      "maxLength": 11
    },
    {
      "code": "+852",
      "name": "香港",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+853",
      "name": "澳門",
      "pattern": "^6\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+886",
      "name": "台灣",
      "pattern": "^9\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+81",
      "name": "日本",
      "pattern": "^[789]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+82",
      "name": "韓國",
      "pattern": "^1[0-9]\\d{7,8}$",
      "placeholder": "請輸入9-10位手機號",
      "maxLength": 10
    },
    {
      "code": "+65",
      "name": "新加坡",
      "pattern": "^[89]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+60",
      "name": "馬來西亞",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+66",
      "name": "泰國",
      "pattern": "^[689]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+62",
      "name": "印度尼西亞",
      "pattern": "^8[1-9]\\d{6,8}$",
      "placeholder": "請輸入8-10位手機號",
      "maxLength": 10
    },
    {
      "code": "+63",
      "name": "菲律賓",
      "pattern": "^9\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+91",
      "name": "印度",
      "pattern": "^[6-9]\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+971",
      "name": "阿聯酋",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+966",
      "name": "沙特阿拉伯",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+90",
      "name": "土耳其",
      "pattern": "^5[0-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+7",
      "name": "俄羅斯",
      "pattern": "^9\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+49",
      "name": "德國",
      "pattern": "^1[5-7]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+33",
      "name": "法國",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+39",
      "name": "意大利",
      "pattern": "^3\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+34",
      "name": "西班牙",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+31",
      "name": "荷蘭",
      "pattern": "^6\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+44",
      "name": "英國",
      "pattern": "^7\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+1",
      "name": "美國/加拿大",
      "pattern": "^[2-9]\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+52",
      "name": "墨西哥",
      "pattern": "^[1-9]\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+55",
      "name": "巴西",
      "pattern": "^[1-9]\\d{10}$",
      "placeholder": "請輸入11位手機號",
      "maxLength": 11
    },
    {
      "code": "+61",
      "name": "澳大利亞",
      "pattern": "^4\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+64",
      "name": "新西蘭",
      "pattern": "^2\\d{7,8}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+27",
      "name": "南非",
      "pattern": "^[6-8]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+93",
      "name": "阿富汗",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+355",
      "name": "阿爾巴尼亞",
      "pattern": "^6[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+213",
      "name": "阿爾及利亞",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+376",
      "name": "安道爾",
      "pattern": "^[3-6]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+244",
      "name": "安哥拉",
      "pattern": "^9[1-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+374",
      "name": "亞美尼亞",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+297",
      "name": "阿魯巴",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+43",
      "name": "奧地利",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "請輸入9-10位手機號",
      "maxLength": 10
    },
    {
      "code": "+994",
      "name": "阿塞拜疆",
      "pattern": "^[4-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+973",
      "name": "巴林",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+880",
      "name": "孟加拉國",
      "pattern": "^1[3-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+375",
      "name": "白俄羅斯",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+32",
      "name": "比利時",
      "pattern": "^4[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+501",
      "name": "伯利茲",
      "pattern": "^6[0-9]\\d{5}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+229",
      "name": "貝寧",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+975",
      "name": "不丹",
      "pattern": "^[1-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+591",
      "name": "玻利維亞",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+387",
      "name": "波黑",
      "pattern": "^6[0-9]\\d{6,7}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+267",
      "name": "博茨瓦納",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+673",
      "name": "文萊",
      "pattern": "^[78]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+359",
      "name": "保加利亞",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+226",
      "name": "布基納法索",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+257",
      "name": "布隆迪",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+855",
      "name": "柬埔寨",
      "pattern": "^[1-9]\\d{7,8}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+237",
      "name": "喀麥隆",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+238",
      "name": "佛得角",
      "pattern": "^[59]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+236",
      "name": "中非",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+235",
      "name": "乍得",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+56",
      "name": "智利",
      "pattern": "^9\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+57",
      "name": "哥倫比亞",
      "pattern": "^3\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+269",
      "name": "科摩羅",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+243",
      "name": "剛果(金)",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+506",
      "name": "哥斯達黎加",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+385",
      "name": "克羅地亞",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+53",
      "name": "古巴",
      "pattern": "^5\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+357",
      "name": "塞浦路斯",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+420",
      "name": "捷克",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+45",
      "name": "丹麥",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+253",
      "name": "吉布提",
      "pattern": "^7[0-9]\\d{5}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+593",
      "name": "厄瓜多爾",
      "pattern": "^9\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+20",
      "name": "埃及",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+503",
      "name": "薩爾瓦多",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+240",
      "name": "赤道幾內亞",
      "pattern": "^[2-3]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+372",
      "name": "愛沙尼亞",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+251",
      "name": "埃塞俄比亞",
      "pattern": "^9\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+679",
      "name": "斐濟",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+358",
      "name": "芬蘭",
      "pattern": "^[4-5]\\d{7,8}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+241",
      "name": "加蓬",
      "pattern": "^[0-1]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+220",
      "name": "岡比亞",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+995",
      "name": "格魯吉亞",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+233",
      "name": "加納",
      "pattern": "^[2-5]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+30",
      "name": "希臘",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "請輸入9-10位手機號",
      "maxLength": 10
    },
    {
      "code": "+502",
      "name": "危地馬拉",
      "pattern": "^[4-5]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+224",
      "name": "幾內亞",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+592",
      "name": "圭亞那",
      "pattern": "^[6-7]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+509",
      "name": "海地",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+504",
      "name": "洪都拉斯",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+36",
      "name": "匈牙利",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+354",
      "name": "冰島",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+98",
      "name": "伊朗",
      "pattern": "^9[0-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+964",
      "name": "伊拉克",
      "pattern": "^7[0-9]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+353",
      "name": "愛爾蘭",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+972",
      "name": "以色列",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+962",
      "name": "約旦",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+254",
      "name": "肯尼亞",
      "pattern": "^[7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+965",
      "name": "科威特",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+996",
      "name": "吉爾吉斯斯坦",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+856",
      "name": "老撾",
      "pattern": "^[2-9]\\d{7,8}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+371",
      "name": "拉脫維亞",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+961",
      "name": "黎巴嫩",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+266",
      "name": "萊索托",
      "pattern": "^[5-6]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+231",
      "name": "利比里亞",
      "pattern": "^[4-7]\\d{6,7}$",
      "placeholder": "請輸入7-8位手機號",
      "maxLength": 8
    },
    {
      "code": "+218",
      "name": "利比亞",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+423",
      "name": "列支敦士登",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+370",
      "name": "立陶宛",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+352",
      "name": "盧森堡",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+261",
      "name": "馬達加斯加",
      "pattern": "^[3-4]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+265",
      "name": "馬拉維",
      "pattern": "^[1-9]\\d{6,8}$",
      "placeholder": "請輸入7-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+960",
      "name": "馬爾代夫",
      "pattern": "^[7-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+223",
      "name": "馬里",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+356",
      "name": "馬耳他",
      "pattern": "^[79]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+222",
      "name": "毛里塔尼亞",
      "pattern": "^[2-4]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+230",
      "name": "毛里求斯",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+373",
      "name": "摩爾多瓦",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+377",
      "name": "摩納哥",
      "pattern": "^[4-6]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+976",
      "name": "蒙古",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+382",
      "name": "黑山",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+212",
      "name": "摩洛哥",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+258",
      "name": "莫桑比克",
      "pattern": "^8[2-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+95",
      "name": "緬甸",
      "pattern": "^9\\d{7,9}$",
      "placeholder": "請輸入8-10位手機號",
      "maxLength": 10
    },
    {
      "code": "+264",
      "name": "納米比亞",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+977",
      "name": "尼泊爾",
      "pattern": "^9[6-8]\\d{8}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+505",
      "name": "尼加拉瓜",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+227",
      "name": "尼日爾",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+234",
      "name": "尼日利亞",
      "pattern": "^[7-9]\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+47",
      "name": "挪威",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+968",
      "name": "阿曼",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+92",
      "name": "巴基斯坦",
      "pattern": "^3\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+507",
      "name": "巴拿馬",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+675",
      "name": "巴布亞新幾內亞",
      "pattern": "^[7-9]\\d{6,7}$",
      "placeholder": "請輸入7-8位手機號",
      "maxLength": 8
    },
    {
      "code": "+595",
      "name": "巴拉圭",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+51",
      "name": "秘魯",
      "pattern": "^9\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+48",
      "name": "波蘭",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+351",
      "name": "葡萄牙",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+974",
      "name": "卡塔爾",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+40",
      "name": "羅馬尼亞",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+250",
      "name": "盧旺達",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+685",
      "name": "薩摩亞",
      "pattern": "^[5-9]\\d{4,6}$",
      "placeholder": "請輸入5-7位手機號",
      "maxLength": 7
    },
    {
      "code": "+378",
      "name": "聖馬力諾",
      "pattern": "^[3-6]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+221",
      "name": "塞內加爾",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+381",
      "name": "塞爾維亞",
      "pattern": "^[6-7]\\d{7,8}$",
      "placeholder": "請輸入8-9位手機號",
      "maxLength": 9
    },
    {
      "code": "+248",
      "name": "塞舌爾",
      "pattern": "^[2-4]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+232",
      "name": "塞拉利昂",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+421",
      "name": "斯洛伐克",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+386",
      "name": "斯洛文尼亞",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+677",
      "name": "所羅門群島",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+252",
      "name": "索馬里",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+249",
      "name": "蘇丹",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+597",
      "name": "蘇里南",
      "pattern": "^[6-8]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+268",
      "name": "斯威士蘭",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+46",
      "name": "瑞典",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+41",
      "name": "瑞士",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+963",
      "name": "敘利亞",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+992",
      "name": "塔吉克斯坦",
      "pattern": "^[4-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+255",
      "name": "坦桑尼亞",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+228",
      "name": "多哥",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+676",
      "name": "湯加",
      "pattern": "^[5-9]\\d{5}$",
      "placeholder": "請輸入6位手機號",
      "maxLength": 6
    },
    {
      "code": "+216",
      "name": "突尼斯",
      "pattern": "^[2-5]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+993",
      "name": "土庫曼斯坦",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+256",
      "name": "烏干達",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+380",
      "name": "烏克蘭",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+598",
      "name": "烏拉圭",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "請輸入8位手機號",
      "maxLength": 8
    },
    {
      "code": "+998",
      "name": "烏茲別克斯坦",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+678",
      "name": "瓦努阿圖",
      "pattern": "^[5-7]\\d{6}$",
      "placeholder": "請輸入7位手機號",
      "maxLength": 7
    },
    {
      "code": "+58",
      "name": "委內瑞拉",
      "pattern": "^4\\d{9}$",
      "placeholder": "請輸入10位手機號",
      "maxLength": 10
    },
    {
      "code": "+84",
      "name": "越南",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+967",
      "name": "也門",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+260",
      "name": "贊比亞",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    },
    {
      "code": "+263",
      "name": "津巴布韋",
      "pattern": "^[7-8]\\d{8}$",
      "placeholder": "請輸入9位手機號",
      "maxLength": 9
    }
  ],
  "en": [
    {
      "code": "+86",
      "name": "Mainland China",
      "pattern": "^1[3-9]\\d{9}$",
      "placeholder": "Please enter 11-digit phone number",
      "maxLength": 11
    },
    {
      "code": "+852",
      "name": "Hong Kong",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+853",
      "name": "Macau",
      "pattern": "^6\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+886",
      "name": "Taiwan",
      "pattern": "^9\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+81",
      "name": "Japan",
      "pattern": "^[789]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+82",
      "name": "South Korea",
      "pattern": "^1[0-9]\\d{7,8}$",
      "placeholder": "Please enter 9-10 digit phone number",
      "maxLength": 10
    },
    {
      "code": "+65",
      "name": "Singapore",
      "pattern": "^[89]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+60",
      "name": "Malaysia",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+66",
      "name": "Thailand",
      "pattern": "^[689]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+62",
      "name": "Indonesia",
      "pattern": "^8[1-9]\\d{6,8}$",
      "placeholder": "Please enter 8-10 digit phone number",
      "maxLength": 10
    },
    {
      "code": "+63",
      "name": "Philippines",
      "pattern": "^9\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+91",
      "name": "India",
      "pattern": "^[6-9]\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+971",
      "name": "UAE",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+966",
      "name": "Saudi Arabia",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+90",
      "name": "Turkey",
      "pattern": "^5[0-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+7",
      "name": "Russia",
      "pattern": "^9\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+49",
      "name": "Germany",
      "pattern": "^1[5-7]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+33",
      "name": "France",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+39",
      "name": "Italy",
      "pattern": "^3\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+34",
      "name": "Spain",
      "pattern": "^[67]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+31",
      "name": "Netherlands",
      "pattern": "^6\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+44",
      "name": "United Kingdom",
      "pattern": "^7\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+1",
      "name": "USA/Canada",
      "pattern": "^[2-9]\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+52",
      "name": "Mexico",
      "pattern": "^[1-9]\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+55",
      "name": "Brazil",
      "pattern": "^[1-9]\\d{10}$",
      "placeholder": "Please enter 11-digit phone number",
      "maxLength": 11
    },
    {
      "code": "+61",
      "name": "Australia",
      "pattern": "^4\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+64",
      "name": "New Zealand",
      "pattern": "^2\\d{7,8}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+27",
      "name": "South Africa",
      "pattern": "^[6-8]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+93",
      "name": "Afghanistan",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+355",
      "name": "Albania",
      "pattern": "^6[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+213",
      "name": "Algeria",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+376",
      "name": "Andorra",
      "pattern": "^[3-6]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+244",
      "name": "Angola",
      "pattern": "^9[1-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+374",
      "name": "Armenia",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+297",
      "name": "Aruba",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+43",
      "name": "Austria",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "Please enter 9-10 digit phone number",
      "maxLength": 10
    },
    {
      "code": "+994",
      "name": "Azerbaijan",
      "pattern": "^[4-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+973",
      "name": "Bahrain",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+880",
      "name": "Bangladesh",
      "pattern": "^1[3-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+375",
      "name": "Belarus",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+32",
      "name": "Belgium",
      "pattern": "^4[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+501",
      "name": "Belize",
      "pattern": "^6[0-9]\\d{5}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+229",
      "name": "Benin",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+975",
      "name": "Bhutan",
      "pattern": "^[1-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+591",
      "name": "Bolivia",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+387",
      "name": "Bosnia and Herzegovina",
      "pattern": "^6[0-9]\\d{6,7}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+267",
      "name": "Botswana",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+673",
      "name": "Brunei",
      "pattern": "^[78]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+359",
      "name": "Bulgaria",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+226",
      "name": "Burkina Faso",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+257",
      "name": "Burundi",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+855",
      "name": "Cambodia",
      "pattern": "^[1-9]\\d{7,8}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+237",
      "name": "Cameroon",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+238",
      "name": "Cape Verde",
      "pattern": "^[59]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+236",
      "name": "Central African Republic",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+235",
      "name": "Chad",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+56",
      "name": "Chile",
      "pattern": "^9\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+57",
      "name": "Colombia",
      "pattern": "^3\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+269",
      "name": "Comoros",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+243",
      "name": "Congo (DRC)",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+506",
      "name": "Costa Rica",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+385",
      "name": "Croatia",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+53",
      "name": "Cuba",
      "pattern": "^5\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+357",
      "name": "Cyprus",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+420",
      "name": "Czech Republic",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+45",
      "name": "Denmark",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+253",
      "name": "Djibouti",
      "pattern": "^7[0-9]\\d{5}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+593",
      "name": "Ecuador",
      "pattern": "^9\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+20",
      "name": "Egypt",
      "pattern": "^1[0-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+503",
      "name": "El Salvador",
      "pattern": "^[67]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+240",
      "name": "Equatorial Guinea",
      "pattern": "^[2-3]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+372",
      "name": "Estonia",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+251",
      "name": "Ethiopia",
      "pattern": "^9\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+679",
      "name": "Fiji",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+358",
      "name": "Finland",
      "pattern": "^[4-5]\\d{7,8}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+241",
      "name": "Gabon",
      "pattern": "^[0-1]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+220",
      "name": "Gambia",
      "pattern": "^[3-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+995",
      "name": "Georgia",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+233",
      "name": "Ghana",
      "pattern": "^[2-5]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+30",
      "name": "Greece",
      "pattern": "^6[0-9]\\d{7,8}$",
      "placeholder": "Please enter 9-10 digit phone number",
      "maxLength": 10
    },
    {
      "code": "+502",
      "name": "Guatemala",
      "pattern": "^[4-5]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+224",
      "name": "Guinea",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+592",
      "name": "Guyana",
      "pattern": "^[6-7]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+509",
      "name": "Haiti",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+504",
      "name": "Honduras",
      "pattern": "^[3-4]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+36",
      "name": "Hungary",
      "pattern": "^[2-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+354",
      "name": "Iceland",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+98",
      "name": "Iran",
      "pattern": "^9[0-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+964",
      "name": "Iraq",
      "pattern": "^7[0-9]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+353",
      "name": "Ireland",
      "pattern": "^[8-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+972",
      "name": "Israel",
      "pattern": "^5[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+962",
      "name": "Jordan",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+254",
      "name": "Kenya",
      "pattern": "^[7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+965",
      "name": "Kuwait",
      "pattern": "^[569]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+996",
      "name": "Kyrgyzstan",
      "pattern": "^[5-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+856",
      "name": "Laos",
      "pattern": "^[2-9]\\d{7,8}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+371",
      "name": "Latvia",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+961",
      "name": "Lebanon",
      "pattern": "^[3-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+266",
      "name": "Lesotho",
      "pattern": "^[5-6]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+231",
      "name": "Liberia",
      "pattern": "^[4-7]\\d{6,7}$",
      "placeholder": "Please enter 7-8 digit phone number",
      "maxLength": 8
    },
    {
      "code": "+218",
      "name": "Libya",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+423",
      "name": "Liechtenstein",
      "pattern": "^[6-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+370",
      "name": "Lithuania",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+352",
      "name": "Luxembourg",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+261",
      "name": "Madagascar",
      "pattern": "^[3-4]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+265",
      "name": "Malawi",
      "pattern": "^[1-9]\\d{6,8}$",
      "placeholder": "Please enter 7-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+960",
      "name": "Maldives",
      "pattern": "^[7-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+223",
      "name": "Mali",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+356",
      "name": "Malta",
      "pattern": "^[79]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+222",
      "name": "Mauritania",
      "pattern": "^[2-4]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+230",
      "name": "Mauritius",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+373",
      "name": "Moldova",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+377",
      "name": "Monaco",
      "pattern": "^[4-6]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+976",
      "name": "Mongolia",
      "pattern": "^[5-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+382",
      "name": "Montenegro",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+212",
      "name": "Morocco",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+258",
      "name": "Mozambique",
      "pattern": "^8[2-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+95",
      "name": "Myanmar",
      "pattern": "^9\\d{7,9}$",
      "placeholder": "Please enter 8-10 digit phone number",
      "maxLength": 10
    },
    {
      "code": "+264",
      "name": "Namibia",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+977",
      "name": "Nepal",
      "pattern": "^9[6-8]\\d{8}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+505",
      "name": "Nicaragua",
      "pattern": "^[5-8]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+227",
      "name": "Niger",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+234",
      "name": "Nigeria",
      "pattern": "^[7-9]\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+47",
      "name": "Norway",
      "pattern": "^[4-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+968",
      "name": "Oman",
      "pattern": "^[7-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+92",
      "name": "Pakistan",
      "pattern": "^3\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+507",
      "name": "Panama",
      "pattern": "^[6-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+675",
      "name": "Papua New Guinea",
      "pattern": "^[7-9]\\d{6,7}$",
      "placeholder": "Please enter 7-8 digit phone number",
      "maxLength": 8
    },
    {
      "code": "+595",
      "name": "Paraguay",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+51",
      "name": "Peru",
      "pattern": "^9\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+48",
      "name": "Poland",
      "pattern": "^[5-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+351",
      "name": "Portugal",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+974",
      "name": "Qatar",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+40",
      "name": "Romania",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+250",
      "name": "Rwanda",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+685",
      "name": "Samoa",
      "pattern": "^[5-9]\\d{4,6}$",
      "placeholder": "Please enter 5-7 digit phone number",
      "maxLength": 7
    },
    {
      "code": "+378",
      "name": "San Marino",
      "pattern": "^[3-6]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+221",
      "name": "Senegal",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+381",
      "name": "Serbia",
      "pattern": "^[6-7]\\d{7,8}$",
      "placeholder": "Please enter 8-9 digit phone number",
      "maxLength": 9
    },
    {
      "code": "+248",
      "name": "Seychelles",
      "pattern": "^[2-4]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+232",
      "name": "Sierra Leone",
      "pattern": "^[2-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+421",
      "name": "Slovakia",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+386",
      "name": "Slovenia",
      "pattern": "^[3-7]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+677",
      "name": "Solomon Islands",
      "pattern": "^[5-9]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+252",
      "name": "Somalia",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+249",
      "name": "Sudan",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+597",
      "name": "Suriname",
      "pattern": "^[6-8]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+268",
      "name": "Swaziland",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+46",
      "name": "Sweden",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+41",
      "name": "Switzerland",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+963",
      "name": "Syria",
      "pattern": "^9[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+992",
      "name": "Tajikistan",
      "pattern": "^[4-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+255",
      "name": "Tanzania",
      "pattern": "^[6-7]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+228",
      "name": "Togo",
      "pattern": "^[6-9]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+676",
      "name": "Tonga",
      "pattern": "^[5-9]\\d{5}$",
      "placeholder": "Please enter 6-digit phone number",
      "maxLength": 6
    },
    {
      "code": "+216",
      "name": "Tunisia",
      "pattern": "^[2-5]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+993",
      "name": "Turkmenistan",
      "pattern": "^[6-8]\\d{7}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+256",
      "name": "Uganda",
      "pattern": "^[7-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+380",
      "name": "Ukraine",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+598",
      "name": "Uruguay",
      "pattern": "^9[0-9]\\d{6}$",
      "placeholder": "Please enter 8-digit phone number",
      "maxLength": 8
    },
    {
      "code": "+998",
      "name": "Uzbekistan",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+678",
      "name": "Vanuatu",
      "pattern": "^[5-7]\\d{6}$",
      "placeholder": "Please enter 7-digit phone number",
      "maxLength": 7
    },
    {
      "code": "+84",
      "name": "Vietnam",
      "pattern": "^[3-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+58",
      "name": "Venezuela",
      "pattern": "^4\\d{9}$",
      "placeholder": "Please enter 10-digit phone number",
      "maxLength": 10
    },
    {
      "code": "+967",
      "name": "Yemen",
      "pattern": "^7[0-9]\\d{7}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+260",
      "name": "Zambia",
      "pattern": "^[6-9]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    },
    {
      "code": "+263",
      "name": "Zimbabwe",
      "pattern": "^[7-8]\\d{8}$",
      "placeholder": "Please enter 9-digit phone number",
      "maxLength": 9
    }
  ]
};


// 获取当前语言的国家数据
export function getCountriesData(language = 'zh-TW') {
  return countriesData[language] || countriesData['zh-TW'];
}

// 获取特定国家的数据
export function getCountryData(code, language = 'zh-TW') {
  const countries = countriesData[language] || countriesData['zh-TW'];
  return countries.find(country => country.code === code);
}

// 获取所有支持的语言
export function getSupportedLanguages() {
  return Object.keys(countriesData);
}

// 获取默认语言
export function getDefaultLanguage() {
  return 'zh-TW';
} 